import { connect } from 'react-redux'
import { deleteItem, editItem } from 'components/Items/actions'
import component from './component'


const mapStateToProps = (state, ownProps) => ({
    isEditing: ownProps.id === ownProps.currentItemId
})

export default connect(
    mapStateToProps,
    {
        editItem,
        deleteItem
    }
)(component)
